import React, {Component} from 'react';
import './item-advantages.scss';
import anime from "animejs";

export default class ItemAdvantages extends Component {

    constructor(props) {
        super(props);

        this.state = {
            viewDesc:false
        };
    }
    componentDidMount() {
        this.target.addEventListener('click', this.viewInfo);
        this.target.addEventListener('onmouseout', ()=>{
            this.setState({
                viewDesc: false
            })
        });
        this.target.addEventListener('onmouseleave', ()=>{
            this.setState({
                viewDesc: false
            })
        });
    }

    viewInfo = () => {
        this.anim = anime({
            targets: [this.target],
            rotateX: ['1turn'],
            borderRadius: '8px',
            duration: 5000,
        });
        this.setState({
            viewDesc: !this.state.viewDesc
        })
    }

    render() {
        return <a  ref={(elm) => {this.target = elm;}} href={this.props.url} className={"body-item-advan cur-p"}>
            {
                this.state.viewDesc ?
                <div className={"cnt-item-advan"}>
                    <div className={"title-advan"}><h2>{this.props.title}</h2></div>
                    <pre className={"desc-itm-advan"}>{this.props.description}</pre>
                </div> :
                <div className={"cnt-item-advan"}>
                    <div className={"title-advan"}><h2>{this.props.title}</h2></div>
                    <img className={"img-advan"} src={this.props.imageMod.default}  width={"3em"} alt=""/>
                </div>
            }

        </a>
    }
}
